@let fieldData = field();

<div class="mb-6">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 x-text-wf-title mb-2"
      [class.font-extrabold!]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }
  @if (getFiles().length > 0) {
    @for (file of getFiles(); track file.src) {
      <div class="text-center mb-4 flex flex-col items-center">
        <img [src]="file.src" [alt]="file.title || ''" class="rounded" />
        @if (file.title) {
          <p class="x-font-body-4 x-text-dark-75 mt-1">{{ file.title }}</p>
        }
      </div>
    }
  }

  <div class="text-center">
    <p
      class="x-font-body-3 whitespace-pre-line x-text-dark-main"
      [class.font-extrabold!]="fieldData.isHighlighted"
      [innerHtml]="fieldData.text"
    ></p>

    @if (fieldData.subtext) {
      <p class="x-font-body-4 x-text-dark-75">{{ fieldData.subtext }}</p>
    }
  </div>
</div>
